import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';

export default class Contacto extends Component {
  render() {
    return (
      <div className='container'>
        <h2>Contacto</h2>
         <Form>
           <FormGroup>
          <Label for="exampleNombre">Nombre</Label>
          <Input type="text" name="nombre" id="examplenombre" placeholder="Nombre" />
        </FormGroup>
        <FormGroup>
          <Label for="exampleEmail">Email</Label>
          <Input type="email" name="email" id="exampleEmail" placeholder="juan@perez.com" />
        </FormGroup>
        <FormGroup>
          <Label for="exampleComentario">Comentario</Label>
          <Input type="textarea" name="comentario" id="examplecomentario" placeholder="comentario placeholder" />
        </FormGroup>
        <Button>Submit</Button>
      </Form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Contacto/index.js